<template>
  <v-container grid-list-xl fluid>
    <v-layout row wrap>
      <v-progress-linear
        indeterminate
        :active="isRequestingNow.length > 0"
        color="blue"
        class="mb-0"
      ></v-progress-linear>
      <v-overlay :value="pageLoading">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
      <v-flex v-if="!pageLoading && item" style="position: relative">
        <v-container class="grey lighten-5">
          <v-row no-gutters class="pagination-table-header">
            <copy-button
              style="position:absolute; top: 0; right: 0;"
              @click="copyToClipboard(item)"
            />
            <v-col
              cols="12"
              sm="4"
              class="py-md-0"
            >
              <datetime-picker
                v-model="item.datetime"
                prepend-icon="mdi-calendar-clock"
                :label="lang($store, 'sap/listings.global.filter.hints.datetime')"
                :rules="[rules.required]"
                :locale="getCurrentLocale()"
                :loading="isRequestingNow.includes('datetime')"
              />
            </v-col>
            <v-col
              cols="12"
              sm="4"
              class="py-md-0"
            >
              <v-select
                v-model="item.order_base_type"
                :items="orderBaseTypeItems"
                prepend-icon="mdi-format-list-bulleted-type"
                single-line
                :hint="lang($store, 'sap/listings.global.filter.hints.order_base_type')"
                persistent-hint
                :error-messages="(errors && errors.order_base_type)?errors.order_base_type:null"
                @change="removeError('order_base_type')"
                :loading="isRequestingNow.includes('order_base_type')"
              ></v-select>
            </v-col>
            <v-col
              cols="12"
              sm="4"
              class="py-md-0"
            >
              <v-select
                v-model="item.order_status"
                :items="orderStatusItems"
                prepend-icon="mdi-cart-arrow-right"
                single-line
                :hint="lang($store, 'sap/listings.global.filter.hints.order_status')"
                persistent-hint
                :error-messages="(errors && errors.order_status)?errors.order_status:null"
                @change="removeError('order_status')"
                :loading="isRequestingNow.includes('order_status')"
              ></v-select>
            </v-col>
            <v-col
              cols="12"
              class="py-md-0 d-flex flex-row justify-space-around align-center"
            >
              <div style="display: inline" class="px-4">
                <v-btn x-small :color="item.is_subscription?'#00bfff':'primary'" @click="changeOrderRelation">
                  {{changeRelationTitle}}
                </v-btn>
              </div>
              <is-ok :is-ok="item.is_contact_ok"
                     @updated="item.is_contact_ok = $event;"
                     :loading="isRequestingNow.includes('is_contact_ok')"
                     :small="false"
              />
              <is-ok icon="mdi-spray-bottle"
                     :is-ok="item.is_cleaner_ok"
                     @updated="item.is_cleaner_ok = $event;"
                     :loading="isRequestingNow.includes('is_cleaner_ok')"
                     :small="false"
              />
              <is-payed
                :is-ok="item.is_payed"
                @updated="item.is_payed = $event;"
                :loading="isRequestingNow.includes('is_payed')"
                style="font-size: 24px"
              />
              <is-presence
                :is-ok="item.is_presence"
                @updated="item.is_presence = $event;"
                :loading="isRequestingNow.includes('is_presence')"
                :small="false"
              />
            </v-col>
            <v-col
              cols="12"
              md="6"
              class="py-md-1"
            >
              <subscription-selector
                v-if="item.is_subscription"
                :required="true"
                :selected-subscription="item.subscription"
                :disable-close="true"
              />
              <address-selector
                v-else
                :required="true"
                :disable-close="true"
                :selected-address="item.address"
              />
              <div>
                <v-text-field
                  v-model="item.minicomment"
                  :counter="200"
                  :rules="[rules.max(200)]"
                  prepend-icon="mdi-tooltip-text-outline"
                  :label="lang($store, 'sap/listings.global.filter.hints.minicomment')"
                  autocomplete="off"
                  :error-messages="(errors && errors.minicomment)?errors.minicomment:null"
                  @input="removeError('minicomment')"
                  class="pt-2"
                  @change="updateRequest('minicomment', $event)"
                  :loading="isRequestingNow.includes('minicomment')"
                ></v-text-field>
              </div>
              <div>
                <v-text-field
                  v-model="item.minicomment2"
                  @change="updateRequest('minicomment2', $event)"
                  :counter="200"
                  :rules="[rules.max(200)]"
                  prepend-icon="mdi-tooltip-text-outline"
                  :label="lang($store, 'sap/listings.global.filter.hints.minicomment2')"
                  autocomplete="off"
                  :error-messages="(errors && errors.minicomment2)?errors.minicomment2:null"
                  @input="removeError('minicomment2')"
                  class="pt-0"
                  :loading="isRequestingNow.includes('minicomment2')"
                ></v-text-field>
              </div>
            </v-col>
            <v-col
              cols="12"
              md="6"
              class="py-md-1 pl-md-3"
            >
              <cleaners-selector
                :selected-cleaners="item.cleaners"
                @updated="item.cleaners = $event; updateCleaners()"
                :error-messages="(errors && errors.cleaners_uuid)?errors.cleaners_uuid:null"
                :dateTime="dateIso"
              />
            </v-col>
            <v-col
              v-if="!!(item.review)"
              cols="12"
              md="6"
              class="py-md-1"
            >
              <view-rating :review="item.review"/>
            </v-col>
          </v-row>
          <v-row>
            <v-col
              cols="12"
              md="6"
              class="py-md-0"
            >
              <div>
                <additional-services-selector
                  :selected="item.additional_services"
                  :info="(
                  typeof item.additional_services_info === 'object'
                  && !Array.isArray(item.additional_services_info)
                ) ? item.additional_services_info
                : {}"
                  @change="
                  item.additional_services = $event.additional_services;
                  item.additional_services_info = $event.additional_services_info;
                  updateRequest('additional_services', $event.additional_services);
                  updateRequest('additional_services_info', $event.additional_services_info);
                "
                />
              </div>
              <div>
                <v-select
                  v-model="item.need_additional_services"
                  :items="needAdditionalServicesItems"
                  :rules="[rules.required]"
                  prepend-icon="mdi-tooltip-text-outline"
                  single-line
                  :hint="lang($store, 'sap/listings.global.filter.hints.need_additional_services')"
                  persistent-hint
                  :error-messages="(errors && errors.need_additional_services)?errors.need_additional_services:null"
                  @change="removeError('need_additional_services')"
                  :loading="isRequestingNow.includes('need_additional_services')"
                ></v-select>
              </div>
              <div>
                <v-select
                  v-model="item.source"
                  :items="sourcesItems"
                  :background-color="(item.is_subscription && item.source === SOURCES.UNSET)?'#00bfff':(SOURCES_COLORS[item.source]
                ?SOURCES_COLORS[item.source]
                :'white')"
                  :item-color="SOURCES_COLORS[item.source] && item.source !== SOURCES.UNSET
                ?SOURCES_COLORS[item.source]
                 :'black'"
                  class="invert-select"
                  :class="item.source"
                  prepend-icon="mdi-arrow-decision-outline"
                  single-line
                  :hint="lang($store, 'sap/listings.global.filter.hints.source')"
                  persistent-hint
                  :error-messages="(errors && errors.source)?errors.source:null"
                  @change="updateRequest('source', $event); removeError('source')"
                  :loading="isRequestingNow.includes('source')"
                >
                  <v-icon v-if="item.is_subscription" slot="prepend" smal color="white"
                          style="background-color: #00bfff">
                    mdi-arrow-decision-outline
                  </v-icon>
                </v-select>
              </div>
              <div class="d-flex mt-4">
                <v-checkbox
                  v-model="item.is_manual_price"
                  color="yellow darken-2"
                  @click.prevent
                  :false-value="0"
                  :true-value="1"
                ></v-checkbox>
                <v-text-field
                  v-model="item.manual_price"
                  :rules="[rules.int_or_null, rules.max(6)]"
                  :label="lang($store, 'sap/listings.global.filter.hints.manual_price')"
                  autocomplete="off"
                  :disabled="!item.is_manual_price"
                  :error-messages="(errors && 'custom_price_data.manual_price' in errors)?lang($store, 'sap/listings.global.validation.price_common'):null"
                  @input="removeError('manual_price')"
                ></v-text-field>
              </div>
              <div>
                <v-text-field
                  v-model="item.note"
                  :counter="200"
                  :rules="[rules.max(200)]"
                  prepend-icon="mdi-tooltip-text-outline"
                  :label="lang($store, 'sap/listings.global.filter.hints.note')"
                  autocomplete="off"
                  :error-messages="(errors && errors.note)?errors.note:null"
                  @input="removeError('note')"
                  @change="updateRequest('note', $event)"
                  :loading="isRequestingNow.includes('note')"
                ></v-text-field>
              </div>
              <div>
                <v-textarea
                  v-model="item.additional_info"
                  :counter="3000"
                  :rules="[rules.max(3000)]"
                  prepend-icon="mdi-account-badge-horizontal-outline"
                  :label="lang($store, 'sap/listings.global.filter.hints.additional_info')"
                  autocomplete="off"
                  :error-messages="(errors && errors.additional_info)?errors.additional_info:null"
                  @input="removeError('additional_info')"
                  @change="updateRequest('additional_info', $event)"
                  :loading="isRequestingNow.includes('additional_info')"
                ></v-textarea>
              </div>
              <div>
                <v-text-field
                  v-model="item.promocode"
                  :counter="50"
                  :rules="[rules.max(50)]"
                  prepend-icon="mdi-tooltip-text-outline"
                  :label="lang($store, 'sap/listings.global.filter.hints.promocode')"
                  autocomplete="off"
                  :error-messages="(errors && errors.promocode)?errors.promocode:null"
                  @input="removeError('promocode')"
                  @change="updateRequest('promocode', $event)"
                  :loading="isRequestingNow.includes('promocode')"
                ></v-text-field>
              </div>
            </v-col>
            <v-col
              cols="12"
              md="6"
              class="py-md-0"
            >
              <div class="mb-2">
                <div>{{ lang($store, 'sap/listings.global.filter.hints.revenue') }}</div>
                <div class="pl-2 v-list v-sheet theme--light v-list--dense v-list--subheader v-list--two-line">
                  <v-text-field
                    type="number"
                    v-model="item.revenue"
                    prepend-icon="mdi-cash-100"
                    :label="$t('table.headers.sum')"
                    autocomplete="off"
                    :error-messages="(errors && errors.revenue)?errors.revenue:null"
                    @input="removeError('revenue')"
                    @change="updateRequest('revenue', $event)"
                    :loading="isRequestingNow.includes('revenue')"
                  ></v-text-field>
                </div>
              </div>
              <div
                v-if="!item.is_subscription"
              >
                <div>Оплаты</div>
                <payments-list
                  :payable-type="ORDERS_BASE"
                  :payable="item"
                />
              </div>
              <div
                v-if="item.is_subscription"
              >
                <subscription-data
                  ref="subscriptionData"
                  :subscription="item.subscription"
                />
              </div>
            </v-col>
          </v-row>
          <v-btn
            small fab dark falt fixed
            right="right"
            class="setting-fab"
            color="red"
            style="top: 54%"
            @click="isShowHistory = true"
            title="Посмотреть историю изменений"
          >
            <v-icon>mdi-history</v-icon>
          </v-btn>
          <v-navigation-drawer
            class="setting-drawer"
            style="z-index: 99;"
            right v-model="isShowHistory" fixed>
            <keep-alive>
              <activity-list
                :args="[this.item.uuid]"
              />
            </keep-alive>
            <div
              class="pa-1"
              @click="isShowHistory = false"
              style="opacity: 0.8; cursor: pointer; background-color: gray;text-align: right; position: absolute; top: 10px; right: 25px; border-radius: 50%; overflow: hidden">
              <v-icon>mdi-close</v-icon>
            </div>
          </v-navigation-drawer>
          <negative-feedback-comment
            title="Создать/посмотреть негатив"
            @click="handleNegativeFeedbackClick"
          />
          <damage-button
            title="Создать/посмотреть ущерб"
            @click="damageClick"
          />
          <accept-dialog
            :is-open-dialog="isShowCreateNegativeDialog"
            @on-close="isShowCreateNegativeDialog = false"
            @on-accept="negativeFeedbackClick"
          >
            <div class="pt-6">
              {{ lang($store, 'sap/listings.global.dialogs.negatives.question') }}
            </div>
          </accept-dialog>
        </v-container>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import i18n from '@/i18n'
import moment from 'moment';
import debounce from 'lodash/debounce';
/* constants */
import * as SOURCES from '~constants/sources';
import { SOURCES_COLORS } from '@/constants/sources_data';
import { ORDERS_BASE } from '@/constants/payable';
import { DATETIME_ISO } from '@/constants/dates';
/* utils */
import { prepareValidationMessages } from '@/utils';
/* proxies */
import OrderBaseProxy from '@/proxies/Order/OrderBaseProxy';
/* mixins */
import updatePageContentMixin from '@/mixins/updatePageContentMixin';
import orderCopyToClipBoardMixin from '@/mixins/orderCopyToClipBoardMixin';
import validationMixin from '@/mixins/validationMixin';
import needAdditionalServicesFilter from '@/mixins/filters/needAdditionalServicesFilter';
import orderBaseTypeFilter from '@/mixins/filters/orderBaseTypeFilter';
import orderStatusFilter from '@/mixins/filters/orderStatusFilter';
import orderBaseUpdateSimpleProp from '@/mixins/orders/orderUpdateSimpleProp';
import sourcesFilter from '@/mixins/filters/sourcesFilter';
import negatable from '@/mixins/negatives/negatable';
import damagable from '@/mixins/damages/damagable';
/* components */

import CopyButton from '@/components/minialerts/CopyButton.vue';
import DatetimePicker from '@/components/DatetimePicker.vue';
import IsOk from '@/components/minialerts/IsOk.vue';
import IsPayed from '@/components/minialerts/IsPayed.vue';
import IsPresence from '@/components/minialerts/IsPresence.vue';
import SubscriptionSelector from '@/components/autocomples/SubscriptionSelector.vue';
import AddressSelector from '@/components/autocomples/AddressSelector.vue';
import CleanersSelector from '@/components/autocomples/CleanersSelector.vue';
import AdditionalServicesSelector from '@/components/selectors/AdditionalServicesSelector.vue';
import PaymentsList from '@/components/listings/PaymentsList.vue';
import SubscriptionData from '@/components/listings/Subsscription/SubscriptionData.vue';
import ActivityList from '@/components/activity/ActivityList.vue';
import ViewRating from '@/components/listings/Orders/ViewRating.vue';
import AcceptDialog from '@/components/AcceptDialog.vue';

export default {
  name: 'ShowBase',
  mixins: [
    updatePageContentMixin,
    orderCopyToClipBoardMixin,
    validationMixin,
    needAdditionalServicesFilter,
    orderBaseTypeFilter,
    orderStatusFilter,
    orderBaseUpdateSimpleProp,
    sourcesFilter,
    negatable,
    damagable,
  ],
  components: {
    CopyButton,
    DatetimePicker,
    IsOk,
    IsPayed,
    IsPresence,
    SubscriptionSelector,
    AddressSelector,
    CleanersSelector,
    AdditionalServicesSelector,
    PaymentsList,
    SubscriptionData,
    ActivityList,
    ViewRating,
    AcceptDialog,
  },
  data() {
    return {
      SOURCES,
      SOURCES_COLORS,
      ORDERS_BASE,
      reportMethodName: 'ordersBaseListingReport',
      negatableType: 'base',
      damagableType: 'base',
      pageLoading: false,
      isShowHistory: false,
      shouldSeeLoaderOnUpdating: true,
      isRequestingNow: [],
      item: null,
      useNullableOrderBaseType: false,
      useNullableOrderStatus: false,
      useNullableSource: false,
      isShowCreateNegativeDialog: false,
      errors: {},
    };
  },
  created() {
    this.pageLoading = true;
    this.fetchData();
  },
  computed: {
    changeRelationTitle() {
      if (!this.item.is_subscription) {
        return i18n.t('orders.show.create_sub');
      }
      return i18n.t('orders.show.delete_sub');
    },
    dateIso() {
      return this.item.datetime ? moment(this.item.datetime).toISOString() : null;
    },
  },
  watch: {
    '$route.params.orderUuid': {
      handler() {
        this.fetchData();
      },
    },
    'item.datetime': {
      handler(newVal) {
        this.updateRequest('datetime', moment(newVal)
          .format(DATETIME_ISO));
      },
    },
    'item.order_base_type': {
      handler(newVal) {
        this.updateRequest('order_base_type', newVal);
      },
    },
    'item.order_status': {
      handler(newVal) {
        this.updateRequest('order_status', newVal);
      },
    },
    'item.is_cleaner_ok': {
      handler(newVal) {
        this.updateRequest('is_cleaner_ok', newVal);
      },
    },
    'item.is_contact_ok': {
      handler(newVal) {
        this.updateRequest('is_contact_ok', newVal);
      },
    },
    'item.is_payed': {
      handler(newVal) {
        this.updateRequest('is_payed', newVal);
      },
    },
    'item.is_presence': {
      handler(newVal) {
        this.updateRequest('is_presence', newVal);
      },
    },
    'item.is_manual_price': {
      handler(newVal) {
          if (!this.pageLoading){
            this.item.manual_price = newVal ? 0 : null;
        }
      }
    },
    'item.manual_price': debounce(function (newVal) {
        this.updateRequest('custom_price_data', {
            is_manual_price: this.item.is_manual_price,
            manual_price: this.item.manual_price
        });
    }, 1000),
    'item.need_additional_services': {
      handler(newVal) {
        this.updateRequest('need_additional_services', newVal);
      },
    },
  },
  methods: {
    fetchData() {
      new OrderBaseProxy().find(this.$route.params.orderUuid)
        .then(response => {
          this.processFetchedData(response.data.data.order);
          this.$route.meta.title = `Заказ: ${this.item.datetime}`;
          return Promise.resolve(this.item);
        })
        .catch(error => {
          console.error(error);
          return this.$router.push({
            name: 404,
          });
        })
        .finally(() => {
          this.pageLoading = false;
          this.$store.dispatch('page/finishUpdateCurrentPageContent');
        });
    },
    processFetchedData(order) {
      const responseOrder = Object.assign({}, order);
      this.$set(responseOrder, 'is_manual_price', order.manual_price === null ? 0 : 1);
      this.item = responseOrder;
      this.$nextTick(() => {
        this.item.manual_price = order.manual_price;
      });
    },
    updateRequest(property, val) {
      if (!this.pageLoading) {
        this.errors = {};
        this.isRequestingNow.push(property);
        (this.updateSimpleRequest(this.item, property))(val)
          .catch(response => {
            this.errors = prepareValidationMessages(response.data.data);
          })
          .finally(() => {
            const index = this.isRequestingNow.indexOf(property);
            if (index !== -1) this.isRequestingNow.splice(index, 1);
          });
      }
    },
    changeOrderRelation() {
      let body = 'Заказ будет откреплен от подписки';
      if (!this.item.is_subscription) {
        body = 'Заказ будет прикреплен к подписке. Если нет активной подписки по данному адресу она будет создана.';
      }
      this.$store.dispatch('confirmer/ask', {
        title: this.changeRelationTitle,
        body,
      })
        .then(confirmation => {
          if (confirmation) {
            this.pageLoading = true;
            new OrderBaseProxy().changeRelation(this.item.uuid)
              .then(response => {
                this.$store.dispatch('page/displaySnackbar', {
                  text: 'Статус обновлен',
                  color: 'primary darken-3',
                  timeout: 3000,
                });
                if (response.data && response.data.data && response.data.data.order) {
                  this.item = response.data.data.order;
                  this.$route.meta.title = `Заказ: ${this.item.datetime}`;
                  if (this.item.is_subscription) {
                    setTimeout(() => {
                      this.$refs.subscriptionData.createNewPayment();
                    }, 1000);
                  }
                }
              })
              .catch(error => {
                console.warn(error);
                switch (error.status) {
                  case 422:
                    this.$store.dispatch('page/displaySnackbar', {
                      text: error.data.data.error,
                      color: 'red darken-3',
                      timeout: 6000,
                    });
                    break;
                  default:
                    console.error(error);
                    alert('Error while requesting');
                    break;
                }
              })
              .finally(() => {
                this.pageLoading = false;
              });
          }
        });
    },
    handleNegativeFeedbackClick() {
      if (!this.item.negative) {
        this.isShowCreateNegativeDialog=true;
      } else {
        this.negativeFeedbackClick();
      }
    },
    /* Helpers */
    updateCleaners() {
      const newVal = this.item.cleaners;
      const cleanersUuid = [];
      if (newVal && newVal.length > 0) {
        newVal.forEach(cleaner => {
          if (cleaner.uuid) {
            cleanersUuid.push(cleaner.uuid);
          }
        });
      }
      this.updateRequest('cleaners_uuid', cleanersUuid);
    },
    getCurrentLocale() {
      return window.localStorage.language;
    }
  },
};
</script>
